export enum MExpenseType {
    'One time costs/ Process costs' = 1,
    'Recurring Expenses' = 2,
  }